import {Dienst} from './dienst';
import {Thuisverzorger} from '../thuisverzorger/thuisverzorger';
import {Client} from '../client/client';
import {ClientDienst} from '../client/client-dienst';
import {Prestatie} from '../prestatie/prestatie';
import {Categorie} from './categorie';
import {Taak} from './taak';

export class Diensten {

  static of(diensten: Array<Dienst>): Diensten {
    return new Diensten(diensten);
  }

  constructor(private diensten: Array<Dienst>) {
  }

  getDiensten(): Array<Dienst> {
    return this.diensten;
  }

  hasDiensten(): boolean {
    return this.diensten.length > 0;
  }

  getDienst(id: string): Dienst {
    return this.diensten.find(dienst => dienst.hasId(id));
  }

  getFirst(): Dienst {
    return this.diensten[0];
  }

  isEmpty(): boolean {
    return this.diensten.length === 0;
  }

  without(dienstIds: string[]): Diensten {
    const diensten = this.diensten
      .filter(dienst => !dienstIds.includes(dienst.getId()));
    return Diensten.of(diensten);
  }

  filterForClientDienst(clientDienst: ClientDienst): Dienst {
    return this
      .getDienst(clientDienst.getId())
      .filterForClient(clientDienst);
  }

  filterForThuisverzorgerAtClient(thuisverzorger: Thuisverzorger, client: Client): Diensten {
    const diensten = this.diensten
      .filter(dienst => thuisverzorger.hasDienstId(dienst.getId()))
      .filter(dienst => client.hasDienst(dienst.getId()));
    return Diensten.of(diensten);
  }

  filterForPrestatie(prestatie: Prestatie): Diensten {
    const diensten = this.diensten
      .filter(dienst => prestatie.hasDienst(dienst.getId()))
      .map(dienst => dienst.filterForPrestatie(prestatie, dienst.getId()))
      .filter(dienst => dienst.hasCategorieen());
    return Diensten.of(diensten);
  }

  filterForClient(client: Client): Diensten {
    const diensten = this.diensten
      .filter(dienst => client.hasDienst(dienst.getId()))
      .map(dienst => dienst.filterForClient(client.getDienst(dienst.getId())))
      .filter(dienst => dienst.hasCategorieen());
    return Diensten.of(diensten);
  }

  getDienstCategorieTaak(dienstId: string, categorieId: string, taakId: string): {dienst: Dienst, categorie: Categorie, taak: Taak} {
      const dienst = this.diensten.find(d => d.hasId(dienstId));
      const categorie = dienst.getCategorieen().find(c => c.hasId(categorieId));
      const taak = categorie.getTaken().find(t => t.hasId(taakId));
      return {dienst, categorie, taak};
  }
}
